<template>
	<div class="text-left ml-3 position-relative">
		<label v-show="showLabel"
			>{{ label }}<span v-show="isMandatory" class="asterik">*</span></label
		>
		<b-skeleton v-if="showLoader || aiLoader" height="80px"></b-skeleton>
		<template v-else>
			<div class="ta-textarea" :class="{ error: error }">
				<b-form-textarea
					:placeholder="!disabled ? 'Enter' : ''"
					rows="1"
					max-rows="4"
					v-model="modelValue[modelKey]"
					style="overflow-y: auto"
					:maxlength="maxlength"
					:disabled="disabled"
				>
				</b-form-textarea>
				<OButton
					v-if="!disabled"
					class="ci-add-disable-btn p-1-14px m-2"
					:disabled="modelValue[modelKey].trim() == ''"
					v-show="showAdd"
					text="Add"
					@clicked="$emit('addText')"
				/>
			</div>
			<template v-if="modelKey === '$model'">
				<span
					v-show="!modelValue.required && modelValue.$dirty"
					class="tu-l0 required-font"
					>Required</span
				>
			</template>
		</template>
	</div>
</template>

<script>
export default {
	name: "TextArea",
	props: {
		showLoader: {
			type: Boolean,
			default: false,
		},
		maxlength: {
			type: Number,
			default: 1000,
		},
		label: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "Enter",
		},
		modelValue: {
			type: Object,
			required: true,
		},
		modelKey: {
			type: String,
			required: true,
		},
		isMandatory: {
			type: Boolean,
			default: true,
		},
		error: {
			type: Boolean,
			default: false,
		},
		showAdd: {
			type: Boolean,
			default: true,
		},
		showLabel: {
			type: Boolean,
			default: true,
		},
		aiLoader: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style>
.ci-add-disable-btn .btn-secondary:disabled {
	border: 1px solid #aaaaaa;
	color: #aaaaaa;
	background: #fff;
	opacity: unset;
}
.ta-textarea {
	background-color: var(--color-white);
	box-shadow: 0px 1px 2px 0px #1018280d;
	border: 1px solid #d0d5dd;
	border-radius: 0.5rem;
	display: flex;
	flex-direction: column;
	align-items: end;
	overflow: hidden;
}
.ta-textarea.disabled {
	background: rgba(140, 140, 140, 0.15) !important;
}

.ta-textarea .form-control {
	border: none;
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-500);
	font-size: var(--size-16);
	color: #565656;
	padding: 10px 14px;
}

.ta-textarea .form-control:focus {
	box-shadow: none;
}
.ta-textarea .form-control::placeholder {
	color: #667085 !important;
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-R);
	font-size: var(--size-14);
}
.p-1-14px .btn-secondary {
	padding: 1px 14px;
}
</style>
